import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useCreateFormTemplateMutation } from '../../../../hooks/mutations/useFormTemplateMutation';
import { useFormTypesQuery } from '../../../../hooks/queries/useFormTypesQuery';
import CustomTextInput from '../../../ui/CustomTextInput';
import DropDown, { OptionType } from '../../../ui/DropDown';
import ModalBody, { ModalProps } from '../../ModalBody';

interface CreateFormModalProps extends ModalProps {
    refetch?: () => void;
}

const CreateFormModal: React.FC<CreateFormModalProps> = ({ open, handleClose, refetch = () => {} }) => {
    const [selectedFormType, setSelectedFormType] = useState<OptionType | null>(null);
    const [formTitle, setFormTitle] = useState('');

    const navigate = useNavigate();

    const { t } = useTranslation();

    const { data: dataFormTypes, isLoading: isFormTypesLoading } = useFormTypesQuery({ queries: { active: true } });
    const { mutate: createFormTemplate } = useCreateFormTemplateMutation({
        onSuccess: (data) => {
            navigate(`/qhse/forms/${data.data._id}`);
            refetch();
        },
    });

    return (
        <ModalBody
            title={t('form')}
            subtitle={t('create')}
            open={open}
            handleClose={handleClose}
            onSubmit={() => {
                if (!selectedFormType) return;
                createFormTemplate({ title: formTitle, typeId: selectedFormType.value });
            }}
            disableSubmit={!formTitle.length || !selectedFormType}
        >
            <CustomTextInput value={formTitle} onChange={(text) => setFormTitle(text)} label={t('title')} required />
            <DropDown
                selectedItem={selectedFormType}
                items={
                    dataFormTypes?.map((formType) => ({
                        label: formType.designation,
                        value: formType._id,
                    })) || []
                }
                handleChange={(event, value) => setSelectedFormType(value)}
                inputLabel={t('formType')}
                loading={isFormTypesLoading}
                required
            />
        </ModalBody>
    );
};

export default CreateFormModal;
